import { Text } from '@loomhq/lens';
import React from 'react';

import styles from './styles.module.less';

export const PageHeader = ({ text }) => {
  return <h1 className={styles.pageHeader}>{text}</h1>;
};

export const PageSubHeader = ({ text }) => {
  return (
    <Text size="large" className={styles.pageSubHeader}>
      {text}
    </Text>
  );
};
